import React, { Suspense, type ReactNode } from 'react';
import { Box, CircularProgress, Skeleton } from '@mui/material';
import { themeColors } from '../Sidebar/const';
import { useGlobalContext } from '../../contexts/globalContext';

type SuspendedProps = {
  children: ReactNode;
  circular?: boolean;
};

export const Suspended = ({ children, circular }: SuspendedProps) => {
  return <Suspense fallback={<FullSizeLoader circular={circular} />}>{children}</Suspense>;
};

export const FullSizeLoader = ({
  circular,
  fullSizeSkeleton
}: {
  circular?: boolean;
  fullSizeSkeleton?: boolean;
}) => {
  const { theme } = useGlobalContext();
  let sx: React.CSSProperties = {
    width: '100%',
    height: '100%',
    zIndex: 1,
    borderRadius: '4px',
    overflow: 'hidden'
  };
  if (circular || fullSizeSkeleton) {
    sx = {
      ...sx,
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.7)'
    };
  }
  return (
    <Box className="transitioned d-flex align-items-center justify-content-center" sx={sx}>
      {circular ? (
        <CircularProgress sx={{ color: themeColors[theme] || 'inherit' }} />
      ) : fullSizeSkeleton ? (
        <Skeleton
          width={'100%'}
          height={'100%'}
          variant="rectangular"
          animation="wave"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            '&::after': {
              background:
                'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.03) 50%, rgba(255,255,255,0.3) 100%)'
            }
          }}
        />
      ) : (
        <Skeleton width={'100%'} height={'100%'} animation="wave" />
      )}
    </Box>
  );
};
